import * as BABYLON from "babylonjs"

export class ImageBlock {
	static create(
		scene: BABYLON.Scene,
		id: string,
		imageUrl: string,
		position: [number, number, number],
		size: [number, number], // Size of the plane [width, height]
		grabbable: boolean,
		visibility: boolean,
		parentID?: string // New parameter for parent ID
	): void {
		const textSize = imageUrl.length * size[0] // Assuming 24 units per character as a heuristic
		const planeWidth = textSize / 1024 // Adjust the plane width based on the text size
		const planeHeight = size[1] // Static height, adjust as needed
		// Create a plane for the image
		const plane = BABYLON.MeshBuilder.CreatePlane(
			id,
			{ width: planeWidth, height: planeHeight },
			scene
		)
		plane.position = new BABYLON.Vector3(position[0], position[1], position[2])
		/*
		// Apply an image texture to the plane
		const material = new BABYLON.StandardMaterial("ImagePlaneMaterial", scene!)
		const texture = new BABYLON.Texture(imageUrl, scene)
		texture.hasAlpha = true // Enable if your image has transparency
		material.diffuseTexture = texture
		material.backFaceCulling = false
		plane.material = material
*/
		// Setting the parent if parentID is provided
		if (parentID) {
			const parentMesh = plane._scene!.getMeshByID(parentID) as BABYLON.Mesh
			if (parentMesh) {
				plane.parent = parentMesh
			}
		}
		if (grabbable) {
			// Instead of PointerDragBehavior, use SixDofDragBehavior for 3D dragging
			const dragBehavior = new BABYLON.SixDofDragBehavior()
			plane.addBehavior(dragBehavior)

			dragBehavior.onDragStartObservable.add(() => {
				console.log("3D dragging started")
			})
			// No onDragObservable here, SixDofDragBehavior does not provide continuous updates like PointerDragBehavior
			dragBehavior.onDragEndObservable.add(() => {
				console.log("3D dragging ended")
			})
		}
		plane.isVisible = visibility
		plane.renderingGroupId = 2
	}
}
